/* eslint-disable prettier/prettier */
import { Box, Typography } from "@mui/material";
import React from "react";

const MonthHeader = ({ month }) => {
  return (
    <Box
      className="sticky-month-header"
      sx={{
        backgroundColor: "#F5F5F5",
        padding: "8px 5px",
        borderRadius: "0 0 4px 4px",
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
        marginBottom: "8px",
        marginTop: "-5px",
        width: "100%",
        display: "flex",
      }}
    >
      <Typography
        variant="caption"
        sx={{
          fontWeight: "bold",
          fontSize: "0.5rem",
          marginLeft: "23px",
        }}
      >
        {month}
      </Typography>
    </Box>
  );
};

export default MonthHeader;